module.exports = __webpack_public_path__ + "img/image14.a97f5655.png";